import "./App.css";
import Navbar from "./Components/Navbar";
import AllRoutes from "./Pages/AllRoutes";

function App() {
  return (
    <div>
      <AllRoutes />
    </div>
  );
}

export default App;
